<template>
  <v-card class="mt-4">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <div id="sticky_notes">
            <v-textarea
              class="ml-3"
              outlined
              v-model="newNote"
              name="input-7-4"
              label="Add Note"
              value=""
              ><v-icon @click="addNote" slot="append" color="primary">
                mdi-plus-circle-outline
              </v-icon>
            </v-textarea>
            <v-spacer></v-spacer>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-card
            v-for="(note, index) in household.sticky_notes"
            :key="index"
            class="d-flex justify-end mb-3 mx-3"
          >
            <v-card-text class="d-flex justify-space-between mb-3 mx-3 mr-0">
              <pre class="notetext">{{ note }}</pre>
              <v-icon
                class="noteicon"
                @click="deleteNote(index)"
                slot="append"
                color="error"
              >
                mdi-minus-circle-outline
              </v-icon>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.notetext {
  font-family: "Roboto", sans-serif;
  white-space: pre-wrap;
}
.noteicon {
  position: relative;
  top: 5px;
  right: 0px;
  align-items: flex-start;
  margin: 0px;
  padding: 0px;
}
</style>

<script>
import hasuraService from "@/services/hasura.service.js";

export default {
  name: "HouseholdNotes",
  mixins: [hasuraService],
  props: {
    household: Object,
  },
  data() {
    return {
      newNote: "",
      notes: [],
      valid: true,
    };
  },
  methods: {
    deleteNote(index) {
      this.household.sticky_notes.splice(index, 1);
      this.updateHouseholdNotes(this.household.id, this.household.sticky_notes);
    },
    addNote() {
      if (this.household.sticky_notes == null) {
        this.household.sticky_notes = [];
      }
      if (this.newNote !== "") {
        this.household.sticky_notes.push(this.newNote);
        this.updateHouseholdNotes(
          this.household.id,
          this.household.sticky_notes
        );
      }
      this.newNote = "";
    },
  },
};
</script>
